/* secondaryMenuSlice.ts */

/* Redux Toolkit */
import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

/* Constants */
import { MenuType } from "src/shared/constants/menu/Menu";

/* Interfaces */
import { SecondaryMenuProps } from "src/shared/interfaces/menu/SecondaryMenu";

const initialState: SecondaryMenuProps = {
  menuType: MenuType.INSIGHTS_FILTER,
  isOpen: false,
  isDisabled: false,
};

export const secondaryMenuSlice = createSlice({
  name: "insightsMenu",
  initialState,
  reducers: {
    setMenuType: (
      state,
      action: PayloadAction<MenuType>
    ) => {
      state.menuType = action.payload;
    },
    openMenu: (state, action: PayloadAction<MenuType>) => {
      state.isOpen = true;
      state.menuType = action.payload;
    },
    closeMenu: (state, action: PayloadAction<MenuType>) => {
      state.isOpen = false;
      state.menuType = action.payload;
    },
    toggleInsightsMenu: (
      state,
      action: PayloadAction<MenuType>
    ) => {
      if (
        state.menuType === action.payload &&
        state.isOpen
      ) {
        state.isOpen = false;
      } else {
        state.menuType = action.payload;
        state.isOpen = true;
      }
    },
    setDisabled: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isDisabled = action.payload;
    },
  },
});

/* Actions */
export const {
  setMenuType,
  openMenu,
  closeMenu,
  toggleInsightsMenu,
  setDisabled,
} = secondaryMenuSlice.actions;

/* Reducer */
export default secondaryMenuSlice.reducer;
